import React from 'react';
import styled from 'styled-components';

const ProgressFull = styled.div`
  width: 94%;
  border-radius: 6px;
  height: 8px;
  background: #eee;
`;

const ProgressBar = styled.div`
  height: 100%;
  width: ${({ value }) => `${value}%`};
  border-radius: 6px;
  background: ${({ color }) => color};
`;

export default ({ color, value }) => {
  return (
    <ProgressFull>
      <ProgressBar value={value} color={color} />
    </ProgressFull>
  );
};
